import React from 'react';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { Dialog, DialogContent } from '@/components/ui/dialog';
const content = {
  genius: {
    content: 'The Genius fee includes a protocol fee that incentivizes liquidity providers to make sure you get the best rates and keep the protocol running as well as any gas fees.',
    title: 'Genius Fee'
  },
  sponsor: {
    content: 'Some blockchains require you to approve tokens before using them and this requires you to have gas in your account. Genius covers this cost for you by sending your account a small amount of gas in the native token of the blockchain you are using. This is taken out automatically from your swap and only happens when you need to approve a new token. Any excess is credited to your account for future use.',
    title: ' Sponsor Fee'
  },
  gas: {
    content: 'Blockchains require gas to process transactions. Genius covers this cost for you by sending your account a small amount of the native blockchain token whenever you are running low. This is taken out automatically from your swap and only happens when you are running low.',
    title: ' Gas Fee'
  },
  dln: {
    content: 'The DeBridge Fee is taken by the DeBridge Network. Trading amounts less than ~20 USD may not be profitable due to this fee. Genius will be deploying its own liquid matching protocol shortly to reduce this fee.',
    title: 'DLN Fee'
  }
};
export default function FeeInfoModal({
  infoType,
  isModalOpen,
  toggleModal
}) {
  const modalContent = content[infoType] || 'No information available for this type.';
  const isMobile = useIsMobile();
  return <>
      {isMobile ? <SlidingModal heightFit={true} isOpen={isModalOpen} onClose={toggleModal}>
          <div className='modal-content p-4 text-[16px] ta-l'>
            <p className='text-genius-cream mb-4'>{modalContent.title}</p>
            <p className='text-genius-cream/50 leading-tight'>{modalContent.content}</p>
          </div>
        </SlidingModal> : <Dialog open={isModalOpen} onOpenChange={x => {
      toggleModal(x);
    }}>
          <DialogContent className='max-lg:max-w-sm max-w-2xl bg-genius-indigo text-genius-cream text-sm'>
            <div className='modal-content p-4 text-[16px] ta-l'>
              <p className='text-genius-cream mb-4'>{modalContent.title}</p>
              <p className='text-genius-cream/50 leading-tight'>{modalContent.content}</p>
            </div>
          </DialogContent>
        </Dialog>}
    </>;
}